import { CertificationConfigTypes } from "./types/certification-config-types";

export const CertificationConfig: CertificationConfigTypes = {
  xxxFeatureToggle: {
    value: "Y",
  },
};
